import type { FC } from 'react'
import { useAppDispatch } from '#app/store'
import { ImportFavoriteSetModal } from '#features/FavoriteSets/ImportFavoriteSetModal'
import { useFavoriteSets } from '#features/FavoriteSets/useFavoriteSets'
import { addFavoriteSet, addFavorites } from '#store/slices/userDataSlice'

export const ConfiguratorImportFavoriteSetModal: FC<{
  open: boolean
  setOpen: (value: boolean) => void
}> = (props) => {
  const { favoriteSets } = useFavoriteSets()
  const dispatch = useAppDispatch()

  return (
    <ImportFavoriteSetModal
      {...props}
      favoriteSets={favoriteSets}
      onAddFavoriteSet={(set) => dispatch(addFavoriteSet(set))}
      onAddFavoritesToSet={(favoriteSetId, entryIds) => dispatch(addFavorites({ favoriteSetId, entryIds }))}
    />
  )
}
